import { useQuery } from '@tanstack/react-query';

import { qkMozartNotifications } from './queryKey';
import { queryClient } from 'tools/tan-stack-query';
import { getAllNotifications } from 'features/mozart-notifications/infra';

export function useGetAllNotifications() {
  return useQuery({
    queryKey: qkMozartNotifications(),
    queryFn: getAllNotifications,
    placeholderData: {
      complaints: [],
      novelties: [],
    },
  });
}

export function invalidateMozartNotifications() {
  queryClient.invalidateQueries(qkMozartNotifications()).then();
}
